<template>
  <el-table-column
    prop="source_user_name"
    sortable="custom"
    label="Cél képviselő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.target_user_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'target_user_name',
  };
</script>
